<template>
	<Container>
		<TopBar />
		<ul class="content">
			<!-- <template v-if='type'>
				
			</template> -->
			<template>
			<li  v-if='activities[0]' class="notice">
				<h3 :class="activities[0].type">{{activities[0].type_desc}}</h3>
				<template v-for='notice in activities'>
					<div class="activities_span">
							<span></span>
							<span>{{notice.title}}</span>
							<span>{{formatNoticeDate(notice.valid_from)}}</span>
					</div>
					<div class='activities_desc' style="" v-html='notice.description'></div>
				</template>
			</li>
			<li  v-if='courses[0]' class="notice">
				<h3 :class="courses[0].type">{{courses[0].type_desc}}</h3>
				<template v-for='notice in courses'>
					<div class='activities_span'>
							<span></span>
							<span>{{notice.title}}</span>
							<span>{{formatNoticeDate(notice.valid_from)}}</span>
					</div>
					<div class='activities_desc' style="" v-html='notice.description'></div>
				</template>
			</li>
			<li  v-if='messages[0]' class="notice">
				<h3 :class="messages[0].type">{{messages[0].type_desc}}</h3>
				<template v-for='notice in messages'>
					<div class='activities_span'>
							<span></span>
							<span>{{notice.title}}</span>
							<span>{{formatNoticeDate(notice.valid_from)}}</span>
					</div>
					<div class='activities_desc' style="" v-html='notice.description'></div>
				</template>
			</li>
			<li  v-if='promotion[0]' class="notice">
				<h3 :class="promotion[0].type">{{promotion[0].type_desc}}</h3>
				<template v-for='notice in promotion'>
					<div class='activities_span'>
							<span></span>
							<span>{{notice.title}}</span>
							<span>{{formatNoticeDate(notice.valid_from)}}</span>
					</div>
					<div class='activities_desc' style="" v-html='notice.description'></div>
				</template>
			</li>
			<li  v-if='rushing[0]' class="notice">
				<h3 :class="rushing[0].type"  >{{rushing[0].type_desc}}</h3>
				<template v-for='notice in rushing'>
					<div class='activities_span'>
							<span></span>
							<span>{{notice.title}}</span>
							<span>{{formatNoticeDate(notice.valid_from)}}</span>
					</div>
					<div class='activities_desc' style="" v-html='notice.description'></div>
				</template>
			</li>
			<li  v-if='lrpt[0]' class="notice">
					<h3 :class="lrpt[0].type">{{lrpt[0].type_desc}}</h3>
					<template v-for='notice in lrpt'>
						<div class="activities_span">
								<span></span>
								<span>{{notice.title}}</span>
								<span>{{formatNoticeDate(notice.valid_from)}}</span>
						</div>
						<div class='activities_desc' style="" v-html='notice.description'></div>
					</template>
				</li>
			</template>
		</ul>
			
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'

    import util from '@/config/util';
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				value1:0,
				notices:[]
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			TopBar
		},
		computed: {
			...mapState({
				
            }),
            lrpt:function(){
                let ret = this.notices.filter(function (item) {return item.type === "LRPT";});
            	return [...(ret || {})];
            },
            activities:function(){
            		let ret = this.notices.filter(function (item) {return item.type === "Activitie";});
            		return [...(ret || {})];
            },  
            courses:function(){
            		let ret = this.notices.filter(function (item) {return item.type === "Course";});
            		return [...(ret || {})];
            },
            messages:function(){
            		let ret = this.notices.filter(function (item) {return item.type === "Message";});
            		return [...(ret || {})];
            }, 
            promotion:function(){
            		let ret = this.notices.filter(function (item) {return item.type === "Promotion";});            	
            		return [...(ret || {})];
            		
            },  
            rushing:function(){
            		let ret = this.notices.filter(function (item) {return item.type === "Rushing";});
            		return [...(ret || {})];
            }      
		},
		methods: {
			...mapActions([
				'initNoticeAction'
			]),
			async initData(){
                this.notices=await this.initNoticeAction();
            },
            formatNoticeDate(date) {
                if (date && date != '') {
                    return util.formatDate.format(date);
                }
                return '';
            },
            back(){
				this.$router.go(-1);
			},
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
    .topbar {
		background-color: #F3F4F5;
		a {
			line-height: 40px;
			margin-left: 10.42vw;
			&:hover {
				color: $theme-color;
			}
		}
	}
    .container {
	
    }
     .breadcrumbPage{
        background-color: #f5f5f5;
        height: 40px;
        line-height: 40px;
    }
    .breadcrumb{
        width: 1104px;
		@include fontSize($font-size-20);
		background-color: #f5f5f5;
		padding: .1rem;
        color: $theme-color;
	}
	.content {
        padding-top: 30px;
        width: 79%;
        margin: auto;
        list-style:none;
        margin-bottom: 50px;
	}
	.notice {
		margin-bottom: 20px;
		h3{
			color: $theme-color;
			border-bottom: 1px dashed $theme-color;
			@include fontSize($font-size-22);
			margin-bottom: 10px;
		}
	}

	.activities_span{
		//margin-left: 20px;
		margin-top: 20px;
		margin-bottom: 5px;
		
		span:nth-child(2){
			@include fontSize($font-size-20);
			font-weight: bold;
		
		}
		span:nth-child(3){
			@include fontSize($font-size-14);
			//margin-left: 20px;
			float:right;
			margin-right: 20px;
		}
	}
	.activities_desc{
		//margin-left: 20px;
		@include fontSize($font-size-14);
	}
	.breadcrumb{
		.goBack{
			float:right;
			margin-right: 20px;
		}
	}
	@media (max-width: 768px){
		.content{
			width: 95%;
		}
		.notice h3{
			font-size: 0.6rem;
		}
		.activities_desc{
			font-size: 0.5rem;
		}
		.activities_span span:nth-child(2){
			font-size: 0.5rem;
		}
		.activities_span span:nth-child(3){
			font-size: 0.5rem;
		}
	
	}
</style>